import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getHistorialStocks,
  updateHistorialStock,
  insertHistorialStock,
  deleteHistorialStock,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_HISTORIAL_STOCKS(action) {
  try {
    const histStockData = yield call(getHistorialStocks, action.payload)
    if (histStockData.ok) {      
      yield put({
        type: actions.HISTORIAL_STOCKS_LOAD_SUCCEEDED,
        payload: histStockData.data.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Historiales Stock')
      put({
        type: actions.HISTORIAL_STOCKS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.HISTORIAL_STOCKS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_HISTORIAL_STOCK(action) {
  try {
    const histStockObj = yield call(insertHistorialStock, action.payload)
    if (histStockObj.ok) {
      putMessage(messageType.SUCCESS, 'Historial Stock creado correctamente')
      yield put({
        type: actions.HISTORIAL_STOCK_INSERT_SUCCEEDED,
        payload: histStockObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Historial Stock')
      yield put({
        type: actions.HISTORIAL_STOCK_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Historial Stock')
    yield all([
      put({
        type: actions.HISTORIAL_STOCK_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_HISTORIAL_STOCK(action) {
  try {
    const histStockObj = yield call(updateHistorialStock, action.payload)
    if (histStockObj.ok) {
      putMessage(messageType.SUCCESS, 'Historial Stock modificado correctamente')
      yield put({
        type: actions.HISTORIAL_STOCK_UPDATE_SUCCEEDED,
        payload: histStockObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Historial Stock')
      yield put({
        type: actions.HISTORIAL_STOCK_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Historial Stock')
    yield all([
      put({
        type: actions.HISTORIAL_STOCK_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_HISTORIAL_STOCK(action) {
  try {
    const histStockResult = yield call(deleteHistorialStock, action.payload)
    if (histStockResult.ok) {
      putMessage(messageType.SUCCESS, 'Historial Stock eliminado correctamente')
      yield put({
        type: actions.HISTORIAL_STOCK_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Historial Stock')
      yield put({
        type: actions.HISTORIAL_STOCK_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Historial Stock')
    yield all([
      put({
        type: actions.HISTORIAL_STOCK_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.HISTORIAL_STOCKS_LOAD_REQUESTED, GET_HISTORIAL_STOCKS),
    takeEvery(actions.HISTORIAL_STOCK_INSERT_REQUESTED, INSERT_HISTORIAL_STOCK),
    takeEvery(actions.HISTORIAL_STOCK_UPDATE_REQUESTED, UPDATE_HISTORIAL_STOCK),
    takeEvery(actions.HISTORIAL_STOCK_DELETE_REQUESTED, DELETE_HISTORIAL_STOCK),
  ])
}
